var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"notification",attrs:{"href":"#"}},[_c('img',{staticClass:"notification__icon",attrs:{"src":'/images/module-icons/'+_vm.formatToPath(_vm.notificationModule)+'.svg'}}),_vm._v(_vm._s(_vm.notificationText))])}
var staticRenderFns = []

export { render, staticRenderFns }